import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { Booking, BookingCategory } from "PFTypes";
import React, { createContext, MutableRefObject, useContext } from "react";

import { Mode } from "./use_booking_bar_dnd";

export interface BookingBarData {
  onLoadingChange: (value?: boolean) => void;
  onBarDragStart: (bookingId: number) => void;
  onBarDragEnd: () => void;
  left: number;
  top: number;
  width: number;
  dayWidth: number;
  id: number;
  endDate: string;
  start: string;
  end: string;
  rowRef: MutableRefObject<HTMLDivElement>;
  disabled: boolean;
  duration: number;
  calculatedLoad: number;
  categoryId: number;
  title: string;
  titleDisabled?: boolean;
  roleBookingsIds: number[];
  isAllBookingsModeEnabled: boolean;
  isRelatedToParentRowActivity?: boolean;
  barsCount: number;
}

export type BookingBarProviderProps = {
  bar: BookingBarData;
  booking: Booking | undefined;
  isLoading: boolean;
  isEditable: boolean;
  draggingMode: Mode | null;
  draggingStartDate: string;
  draggingEndDate: string;
  isSplittable: boolean;
};

type BookingBarContextType = BookingBarProviderProps & {
  category: BookingCategory | undefined;
};

const BookingBarContext = createContext({} as BookingBarContextType);

export const BookingBarProvider = ({
  children,
  bar,
  ...value
}: React.PropsWithChildren<BookingBarProviderProps>): JSX.Element => {
  const { getBookingCategory } = useBookingCategories();
  const category = getBookingCategory(bar.categoryId);
  return (
    <BookingBarContext.Provider value={{ ...value, bar, category }}>{children}</BookingBarContext.Provider>
  );
};

export const useBookingBarContext = () => useContext<BookingBarContextType>(BookingBarContext);
